import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Offcanvas, Button } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      show: false,
      tab: 1
    }
  }

  handleShow() {
    this.setState({
      show: true
    })
  }
  handleClose() {
    this.setState({
      show: false
    })
  }

  changeTab( tab ) {
    this.setState({
      tab: tab
    })
  }

  render() {

    const { show, tab } = this.state,
    { page_data, ajax_data, clientWidth } = this.props

    if('razmeri_1' in ajax_data && ajax_data.razmeri_1 != ``) return (
      <>
        <div style={{ cursor: `pointer` }} onClick={() => this.handleShow()} className={styles.block_product_start_description}>
          <div className='d-flex align-items-center justify-content-between'>
            <div className={styles.block_product_start_description_title}>Размерная сетка и обмеры</div>
            <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.5 10.5L5.5 5.5L0.5 0.5" stroke="black"/>
            </svg>
          </div>
        </div>
        <Offcanvas show={show} onHide={() => this.handleClose()} placement={clientWidth >= 768 ? `end` : `bottom`} className={styles.setka_razmerov}>
          <Offcanvas.Header className={styles.setka_razmerov_title}>
            <svg onClick={() => this.handleClose()} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L15 15" stroke="black"/>
              <path d="M15 1L1 15" stroke="black"/>
            </svg>
            <div>Размерная сетка и обмеры</div>
          </Offcanvas.Header>
          <Offcanvas.Body className={styles.setka_razmerov_body}>
            <div className={styles.setka_razmerov_tabs}>
              <div onClick={() => this.changeTab(1)} className={tab == 1 ? styles.setka_razmerov_tab_active : styles.setka_razmerov_tab}>Таблица размеров</div>
              <div onClick={() => this.changeTab(2)} className={tab == 2 ? styles.setka_razmerov_tab_active : styles.setka_razmerov_tab}>Обмеры изделия</div>
            </div>
            {tab == 1 &&
              <div className={styles.setka_razmerov_tab_content} dangerouslySetInnerHTML={{__html: ajax_data.razmeri_1}}></div>
            }
            {tab == 2 &&
              <div className={styles.setka_razmerov_tab_content} dangerouslySetInnerHTML={{__html: ajax_data.razmeri_2}}></div>
            }
            <div className={styles.setka_razmerov_sizes}>Размеры указаны в см</div>
            <div className={styles.setka_razmerov_nenashli}>
              Не нашли подходящий размер?<br />
              Свяжитесь с нами для уточнения информации
            </div>
            {page_data.phone &&
              <div className={styles.setka_razmerov_phone}>
                <a href={`tel:` + page_data.phone.replace(/[-()\s]/g, '')}>{page_data.phone}</a>
              </div>
            }
            {page_data.tg &&
              <Button href={page_data.tg} target='_blank' className={styles.setka_razmerov_tg} variant="dark">
                <div>Телеграм</div>
                <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.817444 5.85442C0.817444 5.85442 6.71446 3.23916 8.75964 2.31826C9.54366 1.94994 12.2024 0.771182 12.2024 0.771182C12.2024 0.771182 13.4296 0.255522 13.3273 1.50789C13.2932 2.0236 13.0205 3.82849 12.7478 5.78076C12.3387 8.5434 11.8956 11.5638 11.8956 11.5638C11.8956 11.5638 11.8275 12.4111 11.248 12.5584C10.6685 12.7057 9.71406 12.0428 9.54366 11.8954C9.40727 11.7849 6.98714 10.1273 6.10089 9.31692C5.86227 9.09592 5.58959 8.65393 6.13495 8.13821C7.36209 6.92265 8.82781 5.41243 9.71406 4.45472C10.1231 4.01268 10.5321 2.98131 8.82781 4.23368C6.40767 6.03861 4.0216 7.73303 4.0216 7.73303C4.0216 7.73303 3.4762 8.10135 2.45361 7.76983C1.43097 7.43836 0.237932 6.99632 0.237932 6.99632C0.237932 6.99632 -0.580102 6.4438 0.817444 5.85442Z" fill="white"/>
                </svg>
              </Button>
            }
          </Offcanvas.Body>
        </Offcanvas>
      </>
    )
  }
}

Main.propTypes = {
  page_data: PropTypes.object,
  ajax_data: PropTypes.object,
  clientWidth: PropTypes.number
}